import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialFinYear: null,
};

export const finYearSlice = createSlice({
  name: "finYear",
  initialState,
  reducers: {
    updateFinYear: (state, action) => {
      state.initialFinYear = action.payload;
    },
  },
});

export const { updateFinYear } = finYearSlice.actions;
export default finYearSlice.reducer;
